import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const setup = () => {
  const triggers = document.querySelectorAll('[data-w-comparison]');

  triggers.forEach((trigger) => {
    const videos = trigger.querySelectorAll('video');
    videos.forEach((video) => {
      if (video) {
        video.pause();
        video.addEventListener('loadedmetadata', () => {
          video.removeAttribute('autoplay');
          video.currentTime = 0;
          video.pause();
        });
      }
    });

    gsap.to(trigger, {
      scrollTrigger: {
        trigger: trigger,
        start: 'top bottom',
        end: 'bottom top',
        onEnter: () => {
          if (videos)
            videos.forEach((video) => {
              video.play();
            });
        },
        onLeave: () => {
          if (videos)
            videos.forEach((video) => {
              video.pause();
            });
        },
        onEnterBack: () => {
          if (videos)
            videos.forEach((video) => {
              video.play();
            });
        },
        onLeaveBack: () => {
          if (videos)
            videos.forEach((video) => {
              video.pause();
            });
        },
      },
    });
  });
};

export default function Comparison() {
  return {
    init: () => {
      setup();
    },
  };
}
